"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _ReactHTMLPicture = _interopRequireDefault(require("@micado-digital/react-htmlpicture/ReactHTMLPicture"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _GetApp = _interopRequireDefault(require("@material-ui/icons/GetApp"));

var _Item = _interopRequireDefault(require("./Item.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Item = function Item(_ref) {
  var absoluteMediaURLs = _ref.absoluteMediaURLs,
      id = _ref.id,
      data = _ref.data,
      lang = _ref.lang,
      mediaFormats = _ref.mediaFormats,
      resourceURL = _ref.resourceURL,
      webpFallback = _ref.webpFallback,
      _onClick = _ref.onClick;
  var css = (0, _Item.default)();
  var REACT_APP_PATH = process.env.REACT_APP_PATH;
  var media = null;

  if ((0, _isArray.default)(data === null || data === void 0 ? void 0 : data.media)) {
    var _data$media;

    media = data === null || data === void 0 ? void 0 : (_data$media = data.media) === null || _data$media === void 0 ? void 0 : _data$media[0];
  } else {
    media = data === null || data === void 0 ? void 0 : data.media;
  }

  var Download = function Download() {
    var _data$media2, _data$media2$;

    var filename = data === null || data === void 0 ? void 0 : (_data$media2 = data.media) === null || _data$media2 === void 0 ? void 0 : (_data$media2$ = _data$media2[0]) === null || _data$media2$ === void 0 ? void 0 : _data$media2$.filename.replace("webp", "jpg");
    var downloadPath = filename.replace("media", "".concat(lang, "/download/media"));
    return /*#__PURE__*/_react.default.createElement("a", {
      className: (0, _clsx.default)("mco-gallery-03__item-download", css.download),
      href: REACT_APP_PATH + downloadPath,
      download: true
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      variant: "contained",
      color: "primary",
      size: "small",
      startIcon: /*#__PURE__*/_react.default.createElement(_GetApp.default, null)
    }, "Download"));
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("mco-gallery-03__item", "mco-gallery-03__item-".concat(id), css.item)
  }, /*#__PURE__*/_react.default.createElement("div", {
    onClick: function onClick() {
      return _onClick(id);
    }
  }, /*#__PURE__*/_react.default.createElement(_ReactHTMLPicture.default, _extends({
    alt: data === null || data === void 0 ? void 0 : data.title,
    media: media,
    path: !absoluteMediaURLs ? resourceURL !== null && resourceURL !== void 0 ? resourceURL : REACT_APP_PATH : ""
  }, mediaFormats, {
    webpFallback: webpFallback
  }))), (data === null || data === void 0 ? void 0 : data.option) === 1 && /*#__PURE__*/_react.default.createElement(Download, null));
};

Item.propTypes = {
  absoluteMediaURLs: _propTypes.default.bool,
  id: _propTypes.default.number,
  data: _propTypes.default.object,
  mediaFormats: _propTypes.default.object,
  resourceURL: _propTypes.default.string,
  webpFallback: _propTypes.default.bool
};
var _default = Item;
exports.default = _default;